<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Мертвые</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/resources/avatars/big/skeletessa.jpg" width="200" height="300" title="Мертвая" /> <img src="//iwstatic.g.bsrv.su/resources/avatars/big/skelet.jpg" width="200" height="300" title="Мертвый" />
		</p>
		<p><b>Мертвые</b> - много веков назад, когда шла истребительная война рас, <router-link to="/wiki/opis_elfs">Эльфы</router-link> шли на <router-link to="/wiki/opis_gnoms">Гномов</router-link>, <router-link to="/wiki/opis_trols">Тролли</router-link> на <router-link to="/wiki/opis_goblins">Гоблинов</router-link>, <router-link to="/wiki/opis_valkiria">Валькирии</router-link> же пытались всех помирить, но тоже были втянуты в войну, а <router-link to="/wiki/opis_bastards">Бастарды</router-link> старались уничтожить всех и даже Ангелы и Демоны вышли в открытый бой друг против друга. В это время древним колдуном Апокалипсиса, было произнесено страшное заклинание, которое подняло убитых товарищей из могил. Помимо этого, страшное заклинание убило всех существ наделённых хоть одной каплей магического дара. И появилась на свете новая раса, вечно голодная до крови, злая на всех и вся. Раса Мертвых. Единственная раса которая могла найти с ними общий язык, была Раса <router-link to="/wiki/opis_bastards">Бастардов</router-link>. У них было много общего, а главное они хотели уничтожить всё на этой земле. Отличительная черта этой расы, они чуют нутро железа, и могут безошибочно указать, какую руду пустить, на производство клинка, что бы он был смертоносен и упруг, а какую на броню и щит, что бы она была легка и крепка.</p>
		<p><b>Специализация (отличительные особенности расы):</b></p>
		<p>Боевой навык - мускулатура</p>
		<p><em>Описание навыка</em></p>
		<p>Экономический навык - шахтер</p>
		<p><em>Описание навыка</em></p>
		<p>Навык кузнеца (атака) - мастер топоров</p>
		<p><em>Описание навыка</em></p>
		<p>Навык кузница (защита) - мастер щитов</p>
		<p><em>Описание навыка</em></p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisMert',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>